/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>authorization.module.ts</name>
///
/// <description>
///  
///  
///  
/// </description>
///
/// <author>Scott Grau</author>
/// <created>11 Jan 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 11Jan2017  1.0.0000         First cut 
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { NgModule } from '@angular/core'; 
import { AuthorizationDirective } from './shared/authorization.directive';  
import { PermissionsDirective } from './permissions/permissions.directive';   
import { UpgradeFeatureDirective } from './permissions/upgrade-feature.directive';   

@NgModule({
    declarations: [
        AuthorizationDirective ,
        PermissionsDirective,
        UpgradeFeatureDirective
        
    ],
    exports: [
        AuthorizationDirective,
        PermissionsDirective,
        UpgradeFeatureDirective
    ] 
    
   
})
export class AuthorizationModule { }


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authorization/authorization.module.ts